import React, { forwardRef, useContext } from 'react';
import { motion, SVGMotionProps } from 'framer-motion';
import classnames from 'classnames';
import { noTransition } from './utils';
import VizContext from './VizContext';

export interface Props extends Omit<SVGMotionProps<SVGRectElement>, 'animate'> {
  /**
   * Flag for enabling animations.
   */
  animate?: boolean;
}

/**
 * The VizSVGArtboard component should be used within the VizSVG component and
 * provides a background layer that stretches to the artboard bounds (within the axis and
 * padded areas).
 */
const VizSVGArtboard = forwardRef<SVGRectElement, Props>((props: Props, ref) => {
  const { animate, className, opacity = 1, ...rest } = props;
  const {
    artboardLeft,
    artboardTop,
    artboardWidth,
    artboardHeight,
    transition,
  } = useContext(VizContext);

  return (
    <motion.rect { ...rest }
        animate={ { opacity: opacity as number } }
        className={ classnames('Bitviz__artboard Bitviz__artboard-svg', className) }
        height={ artboardHeight }
        initial={ { opacity: 0 } }
        ref={ ref }
        transition={ animate ? transition : noTransition }
        width={ artboardWidth }
        x={ artboardLeft }
        y={ artboardTop } />
  );
});

export default VizSVGArtboard;
